import { createContext } from "react";

/**
 * Project-level filters a per-(table, schedule) editor inherits from, for its dimmed
 * "(from project)" display. Provided by ConnectorVarsForm above every child so the schedules
 * panel is inside it rather than beside it (SIM-3402); null for the nine types without scoping.
 */
export interface PSScopingContextValue {
  projectSchoolIds: string[];
  projectSinceDate: string;
  schoolYearStart?: string;
}

export const PSScopingContext = createContext<PSScopingContextValue | null>(null);
